
export default {
  props: {
    value: {
      type: Number
    },
    prop: {
      type: String
    }
  },
  data: function data() {
    return {
      settingOptions: [{
        label: '100%',
        value: 100,
        quality: 0
      }, {
        label: '90%',
        value: 90,
        quality: 1
      }, {
        label: '80%',
        value: 80,
        quality: 2
      }, {
        label: '70%',
        value: 70,
        quality: 3
      }, {
        label: '60%',
        value: 60,
        quality: 4
      }, {
        label: '50%',
        value: 50,
        quality: 5
      }]
    };
  },

  methods: {
    formatQuality: function formatQuality(val) {
      var item = this.settingOptions.filter(function (item) {
        return item.value === val;
      })[0];
      if (item) {
        return item.label;
      }
      return '';
    },
    changeHandler: function changeHandler(v) {
      this.$emit('input', v);
    }
  }
};